import React from 'react';
import classNames from 'classnames';

import styles from './typography.module.scss';

export type Variant =
    | 'heading'
    | 'title'
    | 'subtitle1'
    | 'subtitle2'
    | 'subtitle3'
    | 'body1'
    | 'body2'
    | 'body3'
    | 'caption'
    | 'button';

interface OwnProps {
    variant: Variant;
    component?: React.ElementType<React.HTMLAttributes<HTMLElement>>;
}

export type TypographyProps = OwnProps & React.HTMLAttributes<HTMLElement>;

const defaultVariantMapping = {
    heading: 'h1',
    title: 'h2',
    subtitle1: 'h3',
    subtitle2: 'h4',
    subtitle3: 'h5',
    body1: 'p',
    body2: 'p',
    body3: 'p',
    caption: 'span',
    button: 'span',
};

const Typography: React.FC<TypographyProps> = (props) => {
    const { variant, component, className, ...rest } = props;

    const Component = component || defaultVariantMapping[variant];
    const componentClassName: string = classNames(className, styles[variant], styles.typography);

    return <Component {...rest} className={componentClassName} />;
};

export { Typography };
